import Modal from '@Common/Modal';
import { MoonLoader } from 'react-spinners';
import { IoIosWarning } from 'react-icons/io';
interface RemoveAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleCancelDelete: () => void;
  handleConfirmDelete: () => void;
  isDeleting: boolean;
  emailToDelete: string;
}
const RemoveAccountModal: React.FC<RemoveAccountModalProps> = ({
  isOpen,
  onClose,
  handleCancelDelete,
  handleConfirmDelete,
  isDeleting,
  emailToDelete,
}) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} title="Remove Account">
        <div className="flex flex-row items-center gap-2">
          <IoIosWarning className="text-red-600" size={35} />
          <span className="text-xl font-bold text-gray-700">
            Remove Account
          </span>
        </div>
        <p className="mt-2 text-sm font-medium text-gray-500">
          Are you sure you want to remove this account?
        </p>
        <div className="text-sm font-bold text-gray-800">{emailToDelete}</div>
        <div className="mt-4 flex justify-end gap-2 text-sm">
          <button
            className="rounded px-3 py-1 text-sm font-medium text-gray-800 hover:bg-gray-200 hover:text-gray-500"
            onClick={handleCancelDelete}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="rounded bg-red-600 px-3 py-1 text-sm font-medium text-white hover:bg-red-600"
            onClick={handleConfirmDelete}
            disabled={isDeleting}
          >
            <div className="flex items-center justify-center">
              {isDeleting ? <MoonLoader size={15} color="#ffffff" /> : 'Remove'}
            </div>
          </button>
        </div>
      </Modal>
    </>
  );
};

export default RemoveAccountModal;
